import { UploadFile } from "@king-ict/eupisi-ui/models";

import { MzomAppeal, MzomAppealSavePayload } from "../../../models/Request";
import { Attachment } from "../../../models/Shared/Attachment";
import { hasNonEmptyValues, pickNonEmpty } from "../../../utils/objectUtils";
import {
  MAX_MZOM_APPEAL_FILES,
  MAX_MZOM_APPEAL_TEXT_LENGTH,
} from "./constants";

export { parseOptionalNumber as parseOptionalEnumValue } from "../../../utils/objectUtils";

const MZOM_APPEAL_SAVE_FIELDS = [
  "typeId",
  "status",
  "outcomeId",
  "classification",
  "associationNumber",
  "note",
  "enrolledInstitutionId",
  "attachments",
  "uploadFiles",
] as const;

export const appendToExistingAppeal =
  (appeal: MzomAppeal) =>
  (arr: UploadFile[] | Attachment[], key: keyof MzomAppeal) => {
    return {
      ...appeal,
      [key]: arr.length ? arr : undefined,
    };
  };

export const getMzomAppealDocumentCount = (appeal: MzomAppeal) =>
  (appeal.attachments?.length ?? 0) + (appeal.uploadFiles?.length ?? 0);

export const canAddMzomAppealDocument = (appeal: MzomAppeal) =>
  getMzomAppealDocumentCount(appeal) < MAX_MZOM_APPEAL_FILES;

export const canSaveMzomAppeal = (appeal: MzomAppeal) => {
  const classification = appeal.classification?.trim() ?? "";
  const associationNumber = appeal.associationNumber?.trim() ?? "";

  return (
    hasNonEmptyValues([
      appeal.typeId,
      appeal.status,
      appeal.outcomeId,
      classification,
      associationNumber,
      appeal.enrolledInstitutionId,
    ]) &&
    classification.length <= MAX_MZOM_APPEAL_TEXT_LENGTH &&
    associationNumber.length <= MAX_MZOM_APPEAL_TEXT_LENGTH
  );
};

export const toMzomAppealSavePayload = (
  appeal: MzomAppeal
): MzomAppealSavePayload => ({
  id: appeal.id,
  requestId: appeal.requestId,
  ...pickNonEmpty(appeal, MZOM_APPEAL_SAVE_FIELDS),
});
